import { FastPhonicsReportPath, FeatureNotificationId } from 'teacher-ui-client/services/feature-notification'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import type ImpressionService from 'teacher-ui-client/services/impression'
import { SideNavAccordionItem, SideNavAccordionList } from 'teacher-ui-client/components/side-nav/accordion'
import graphUnfilled from '@images/icons/graph-unfilled.svg'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'
import { Lozenge } from 'teacher-ui-client/components/lozenge'
import { t } from 'ember-intl'
import { FeatureNotification } from 'teacher-ui-client/helpers/feature-notification'

export class FastPhonicsReportsAccordion extends Component<unknown> {
  @service impression!: ImpressionService

  @service sideNav!: SideNavService

  get uiScopeModels() {
    return this.sideNav.uiScopeModels ?? []
  }

  get hasNewFastPhonicsReports() {
    return Object.values(FastPhonicsReportPath).some((reportPath) => {
      return !this.impression.wasMade(reportPath)
    })
  }

  <template>
    <SideNavAccordionList
      @iconUrl={{graphUnfilled}}
      @iconAlt="Sidenav bar"
      @label={{t "sideNav.reports.title"}}
      @showNotificationDot={{this.hasNewFastPhonicsReports}}
    >
      <SideNavAccordionItem
        @route="reporting.ui-scope.fast-phonics.dashboard"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="FP" page="dashboard"}}
      >{{t "sideNav.reports.dashboard"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.fast-phonics.progress.review"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="FP" page="progress-review"}}
      >{{t "sideNav.reports.progress"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.fast-phonics.time-on-task"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="FP" page="time-on-task"}}
      >{{t "sideNav.reports.timeOnTask"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        data-test-fp-standards-performance
        @route="reporting.ui-scope.fast-phonics.standards-performance"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="FP" page="standards-performance"}}
      >{{t "sideNav.reports.standards"}}
        {{#if
          (FeatureNotification
            FeatureNotificationId.NewReportForPath reportPath=FastPhonicsReportPath.StandardsPerformance
          )
        }}
          <Lozenge data-test-reading-new-lozenge>{{t "new"}}</Lozenge>
        {{/if}}
      </SideNavAccordionItem>
      <SideNavAccordionItem
        data-test-fp-lesson-performance
        @route="reporting.ui-scope.fast-phonics.lesson-performance"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="FP" page="lesson-performance"}}
      >{{t "sideNav.reports.lessonPerformance"}}
        {{#if
          (FeatureNotification
            FeatureNotificationId.NewReportForPath reportPath=FastPhonicsReportPath.LessonPerformance
          )
        }}
          <Lozenge data-test-reading-new-lozenge>{{t "new"}}</Lozenge>
        {{/if}}
      </SideNavAccordionItem></SideNavAccordionList>
  </template>
}

export default FastPhonicsReportsAccordion
